import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { AppData } from 'src/app/app.data';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { ApiResponseCode } from '../enums';
import { SendFormToCustomerModel } from '../models/send-form-to-customer-model';
import { SendFormToTherapistModel } from '../models/send-form-to-therapist-model';
import { Utils } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  settings: Settings;
  apiEndPoint: string = Utils.getApiEndPoint(); // environment.APIEndpoint;
  
  public static SEND_TO_CUSTOMER = 'SEND_TO_CUSTOMER';
  public static FILL_BY_THERAPIST = 'FILL_BY_THERAPIST';


  public data: any = {}; // helper object to save data between stages


  constructor(private http: HttpClient,
    private appSettings: AppSettings,
    private route: ActivatedRoute,
    private appData: AppData) { 

      this.settings = appSettings.settings;
    }


    getForms(){
      return this.http.get<any>(this.apiEndPoint + `FormApi/GetFormsToSend`)
      .pipe(map(result => {
        return result;
      }));
    }

    sendFormToCustomer(model: SendFormToCustomerModel){
      return this.http.post<any>(this.apiEndPoint + `FormApi/SendFormsToCustomer`, JSON.stringify(model))
      .pipe(map(result => {        
        return result;
      }));
    }

    sendFormToTherapist(model: SendFormToTherapistModel){
      return this.http.post<any>(this.apiEndPoint + `FormApi/FillFormByTherapist`, JSON.stringify(model))
      .pipe(map(result => {        
        return result;
      }));
    }


    
}
